import { getDLGlobalParams } from '@js/utilities/datalayerHelpers';
import '@js/abstracts/dataLayer';
import '@js/abstracts/algoliaAnalytics';
import '@js/abstracts/recombeeAnalytics';
import '@js/vendors/livewire';
import telInputHandler from '@js/utilities/inputTel';

// window.gtag('consent', 'default', {
//     ad_storage: 'denied',
//     analytics_storage: 'denied',
//     wait_for_update: 2000,
// });

window.dataLayer.push(getDLGlobalParams());

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((event) => {
    window.addEventListener(event, (e) => {
        const container = e.container ?? null;

        telInputHandler(container);
    });
});
